import { jsx as _jsx } from "react/jsx-runtime";
const Content = ({ children, center, fitContent }) => {
    return center ?
        _jsx("div", { className: 'flex flex-col self-center grow w-full h-full min-h-0', children: _jsx("div", { className: 'flex self-center grow w-full h-full min-h-0', children: _jsx("div", { className: 'flex flex-col self-center w-full grow h-full min-h-0', children: children }) }) })
        : _jsx("div", { className: fitContent ? 'min-h-0 flex w-full' : 'h-full min-h-0 grow flex flex-1 w-full', children: children });
};
export default Content;
